import { AxiosResponse } from "axios";
import axiosInstance from "../../api";
import suggestiveInputHelpers from "../helpers/suggestiveInputHelpers";

function LaboratorySideEffect(
  token: string,
  search: string,
  setSuggestions: (response: AxiosResponse) => any
) {
  axiosInstance
    .get(`/v1/pathology/new-flow/?search=${search}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (response.data.data) {
        setSuggestions(
          response.data.data
            .sort(suggestiveInputHelpers.sortByAlphabeticalOrder)
            .map((item: any) => ({
              label: `${item.DataRecordName}`,
              value: item.id,
              ...item,
            }))
        );
      }
    });
}

export default LaboratorySideEffect;
